import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { Button, Typography } from 'components';
import TextArea from 'antd/es/input/TextArea';
import { CloseIcon, DoneIcon } from 'components/common/icons';
import { useCommentCreateMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { Comments } from 'components/common/comments';

export const TaskComments = React.memo(
  ({ hasAccessToWrite, id, isFinalStatus }: { hasAccessToWrite: boolean; id: string; isFinalStatus?: boolean }) => {
    const { handleError, handleSuccess } = useNotificationMessages();
    const [loading, setLoading] = useState(false);
    const [onFocus, setOnFocus] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const [addComment] = useCommentCreateMutation();

    const onCancel = useCallback(() => {
      setOnFocus(false);
    }, []);

    const onAddComment = useCallback(
      async (e: any) => {
        e.stopPropagation();
        setLoading(true);
        try {
          const { data, error }: any = await addComment({
            entityName: 'TASK',
            entityId: id,
            message: comment,
          });
          if (data?.success) {
            handleSuccess('The comment has been successfully added.');
            setOnFocus(false);
          } else {
            handleError(error);
          }
        } catch (err) {
          console.log(err, 'error');
        } finally {
          setLoading(false);
        }
      },
      [id, comment, addComment, handleSuccess, handleError]
    );

    useEffect(() => {
      !onFocus && setComment('');
    }, [onFocus]);

    return (
      <Row gutter={[0, 12]}>
        <Typography.Text className={'font-size-16'} style={{ color: '#05796B', fontWeight: 600 }}>
          Comments
        </Typography.Text>
        <Col span={24}>
          {hasAccessToWrite && (
            <TextArea
              disabled={isFinalStatus}
              value={comment}
              rows={3}
              onFocus={() => setOnFocus(true)}
              onChange={(e) => setComment(e.target.value)}
              placeholder={'Add Comment'}
            />
          )}
        </Col>
        <Col span={24}>
          {onFocus && (
            <Row gutter={4} justify={'end'}>
              <Col>
                <Button disabled={loading} color="default" variant="filled" onClick={onCancel} icon={<CloseIcon />} />
              </Col>
              <Col>
                <Button
                  disabled={!comment || loading}
                  type={'primary'}
                  icon={<DoneIcon />}
                  onMouseDown={onAddComment}
                />
              </Col>
            </Row>
          )}
        </Col>
        <Col span={24}>
          <Comments id={id} entityName={'TASK'} />
        </Col>
      </Row>
    );
  }
);
